// src/LogIn.js
import { Component } from 'react';
import { properties } from './properties.js';
import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';
import { apiPublicRequest, apiSecuredRequest } from './functions.js';
import NavBar from './LogInNavBar.js';
import { cargarIdiomaPreferido } from './functions.js';
import i18n from './I18N/I18n.js'; 
import './css/logIn.css'; // Importar los estilos

class LogIn extends Component {
  async componentDidMount() {
    await cargarIdiomaPreferido(this.cambiarIdioma);
  }

  cambiarIdioma = (idioma) => {
    const { i18n } = this.props;
    i18n.changeLanguage(idioma);
    this.forceUpdate();
    Cookies.set('idiomaPreferido', idioma, { expires: 365 });
    Cookies.remove('email');
  };

  _logIn = async (nombre, password) => {
    let data = JSON.stringify({
      email: nombre,
      password: password,
    });

    try {
      const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/empresas/login`, data);

      if (bearerToken.status === 200) {
        let userMail = JSON.stringify({
          email: nombre,
        });
        const userData = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUser`, userMail, bearerToken.data.accessToken);
        const usuario = userData.data;

        Cookies.set('email', usuario.email);
        Cookies.set('rol', usuario.rol);
        Cookies.set('id', bearerToken.data.accessToken);

        if (usuario.active === 'false') {
          localStorage.setItem('firstLogin', 'true');
          window.location.href = `/changePass`;
        } else {
          localStorage.setItem('usuario', JSON.stringify(usuario));
          window.location.href = `/listaEmpresas`;
        }
      } else {
        this.setState({ incorrectUser: true, userName: '', userPassword: '' });
      }
    } catch (err) {
      this.setState({ incorrectUser: true, userName: '', userPassword: '' });
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      incorrectUser: false,
      userName: '',
      userPassword: '',
    };
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    return (
      <div className="container">
        <div className="content">
          <NavBar cambiarIdioma={this.cambiarIdioma} />

          <h2 className="custom-login-title">Login</h2>

          <form
            onSubmit={(event) => {
              event.preventDefault();
              this._logIn(this.state.userName, this.state.userPassword);
            }}
            className="custom-login-form"
          >
            <input
              type="text"
              name="userName"
              value={this.state.userName}
              onChange={this.handleInputChange}
              placeholder="Email"
              className="custom-input-field"
              required
            />

            <input
              type="password"
              name="userPassword"
              value={this.state.userPassword}
              onChange={this.handleInputChange}
              placeholder="Password"
              className="custom-input-field"
              required
            />

            <div className="custom-button-container">
              <button type="submit" className="custom-btn">
                Log In
              </button>

              <button
                type="button"
                className="custom-btn"
                onClick={() => {
                  window.location.href = `/`;
                }}
              >
                {i18n.t('back')}
              </button>
            </div>

            <p className="custom-forgot-password">
              <a href="/resetPassword">{i18n.t('forgotPassword')}</a>
            </p>

            {this.state.incorrectUser && (
              <p className="custom-error-message">
                {i18n.t('back')}The information is wrong, please try again
              </p>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(LogIn);
